import { withSentry } from '../modules/sentry';
import $dom from 'cash-dom';

import vueCustomElement from 'vue-custom-element';
import Vue from 'vue';
import { globalEventBusPlugin } from '@pixelcabin/ui-utils/lib/vue';

import TabThumbnailSwitcher from '../components/TabThumbnailSwitcher/TabThumbnailSwitcher.vue';
import { tabThumbnailSwitcherPreprocess } from '../components/TabThumbnailSwitcher/preprocess_props';

$dom(document).ready(
  withSentry(() => {
    console.log('[pages] initializing scripts');
    Vue.use(globalEventBusPlugin);
    Vue.use(vueCustomElement);

    Vue.customElement(
      'pxl-tab-thumbnail-switcher',
      TabThumbnailSwitcher,
      tabThumbnailSwitcherPreprocess
    );
  })
);
